import {
    Box,
    Button,
    Card,
    Icon,
    IconButton,
    Skeleton,
    styled,
    Typography,
} from '../../../base';
import { AlertSeverity } from '../../../common';

export const StyledCardHeader = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 0,
}));

export const StyledHeaderContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    paddingBottom: theme.spacing(1),
}));

export const StyledClearAllButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '0.75rem',
    minWidth: 'unset',
    color: theme.palette.text.secondary,
}));

export const StyledNotificationsContainer = styled(Box)(() => ({
    height: '100%',
    overflowY: 'auto',
    flex: 1,
}));

export const StyledAlertItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 0, 1, 1),
    '&:last-child': {
        borderBottom: 'none',
    },
    minHeight: '24px',
}));

interface StyledFlagIconProps {
    severity: AlertSeverity;
}

export const StyledFlagIcon = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'severity',
})<StyledFlagIconProps>(({ theme, severity }) => {
    const getColor = () => {
        switch (severity) {
            case AlertSeverity.ERROR:
                return theme.palette.error.main; // Red for urgent
            case AlertSeverity.WARNING:
                return theme.palette.warning.main; // Yellow for warning
            default:
                return theme.palette.text.disabled; // No color (gray) for default
        }
    };

    return {
        color: getColor(),
        marginInlineEnd: theme.spacing(1.5),
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
});

export const StyledDateText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    marginInlineEnd: theme.spacing(1.5),
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
    flexShrink: 0,
}));

export const StyledCloseButton = styled(IconButton)(({ theme }) => ({
    padding: 2,
    borderRadius: '4px',
    marginInlineStart: theme.spacing(0.5),
}));

export const StyledNotificationsIconWrapper = styled(IconButton)(
    ({ theme }) => ({
        marginInlineEnd: theme.spacing(1),
        height: '55px',
        width: '55px',
        '&:disabled': {
            backgroundColor: theme.palette.background.mainBackground,
        },
    })
);

export const StyledNotificationsIcon = styled(Icon)(({ theme }) => ({
    color: theme.palette.secondary.main,
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.spacing(1),
}));

export const StyledWrapperCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2),
    height: '100%',
    maxHeight: '260px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.shape.borderRadius,
}));
